export default {
  fulfillment_rate: "معدل التنفيذ",
  revenue: "الإيرادات",
  new_orders: "طلبات جديدة",
  expiring_today: "ينتهي اليوم",

  sales: "المبيعات",
  orders: "الطلبات",
};